import { FC, useEffect } from "react";
import { disableSplashScreen, enableSplashScreen } from "./LayoutProvider";

export const LayoutSplashScreen: FC = () => {
  useEffect(() => {
    enableSplashScreen();

    return () => {
      disableSplashScreen();
    };
  }, []);

  return null;
};
